var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4219 0.32666H2.42188C1.32187 0.32666 0.431875 1.22666 0.431875 2.32666L0.421875 14.3267C0.421875 15.4267 1.32187 16.3267 2.42188 16.3267H18.4219C19.5219 16.3267 20.4219 15.4267 20.4219 14.3267V2.32666C20.4219 1.22666 19.5219 0.32666 18.4219 0.32666ZM18.4219 4.32666L10.4219 9.32666L2.42188 4.32666V2.32666L10.4219 7.32666L18.4219 2.32666V4.32666Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmail);
export default __webpack_public_path__ + "static/media/ic_email.7fc70f490175b5a077feee954ca10be8.svg";
export { ForwardRef as ReactComponent };